import React from 'react';

const Spinner = () => <div className="loader" />;

export default Spinner;
